export default "__VITE_ASSET__DZph6XVO__"